import { atom, useAtom, useSetAtom } from "jotai";
import { PrimitiveAtom } from "jotai/vanilla";

export const confirmAtom = atom(null) as PrimitiveAtom<{
  message: string | React.ReactNode;
  cb: () => void;
}>;

const useConfirm = () => {
  const atom = useAtom(confirmAtom);
  return atom;
};

export const useSetConfirm = () => useSetAtom(confirmAtom);

export default useConfirm;
